import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { selectAllCategories, loadCategories } from "./categoriesSlice";

const CategoriesAside = ({ onchange, name }) => {
  const dispatch = useDispatch();
  const allCategories = useSelector(selectAllCategories);

  const checkStatus = useSelector((state) => state.categories.status);

  useEffect(() => {
    if (checkStatus === "idle") {
      dispatch(loadCategories("popular"));
    }
  });

  return (
    <div className="subreddit">
      <h2 className="subreddit-title">Subreddits</h2>
      {/*
      {checkStatus === "loading" && <div>loading categories</div>}
      {checkStatus === "failed" && (
        <div>Error while loading categories. Please try again...</div>
      )}*/}
      <div>
        {allCategories.map((item) => {
          return (
            <div className="subredditItems">
              <input
                type="radio"
                name="subreddit"
                value={item.data.subreddit}
                key={item.id}
                onChange={onchange}
              />
              <label name="subreddit">{item.data.subreddit}</label>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CategoriesAside;
